/**
 * [mutations description]
 * @type {Object}
 */
import abLS from '@/business/abLocalStorage'

var mutations = {
  setHotelId(state, hotelId) {
    state.hotelId = hotelId
    abLS.setHotelId(hotelId)
  },
  setHotelInfo(state, hotelInfo) {
    state.hotelInfo = hotelInfo
    abLS.setHotelInfo(hotelInfo)
  },
  setHotelList(state, hotelList) {
    state.hotelList = hotelList
    abLS.setHotelList(hotelList)
  },
  setAllowHotelCount(state, allowHotelCount) {
    state.allowHotelCount = allowHotelCount
  },
  setIsBindWechart(state, isBindWechart) {
    state.isBindWechart = isBindWechart
  },
  setHotelCityCn(state, cityCn) {
    state.cityCn = cityCn
    abLS.setHotelCityCn(cityCn)
  },
}

export default mutations
